import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import "~/Pages/Track/TrackPage.less";

import { useUser } from "~/Context/userContext";
import { AuthorName } from "~/Components/Elements/ChimneyName";
import DetailsBody from "~/Components/Elements/DetailsBody";
import CommentsList from "~/Components/Elements/CommentsList";
import styled from "styled-components";

export const DateWrapper = styled.section`
  display: inline-block;
  font-size: 12px;
  margin-left: 6px;
`;

export const MessageBoardTopic = ({ topic, loading, preview }) => {
  const { state: userState } = useUser();

  function createTopicComment(comment) {
    return { __html: comment };
  }

  const canEdit = userState.loggedin && userState.user && userState.user.dir === topic.thread_author.dir;

  const allowHtml = topic.thread_author && topic.thread_author.user_type.match(/^(chim|user)$/);

  return (
    <div className="totd-mb-topic page-layout-topic">
      <Row>
        <Col xs={12} className="track-topic-box">
          {loading && (
            <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
              <Skeleton count={1} />
            </SkeletonTheme>
          )}
          {!loading && topic && (
            <div className="totd-topic-wrapper">
              <h3>
                <FontAwesomeIcon icon="cubes" className="cubes fa mr fa-cubes" />
                {topic.subject}
              </h3>
              <DetailsBody edit={canEdit}>
                {!preview && canEdit && (
                  <span className="inline-edit-icon">
                    {(loading && <FontAwesomeIcon icon={faSpinner} spin />) || (
                      <Link to={`/message-board/topic/${topic.id}/edit`}>
                        <span onClick={() => {}}>
                          <FontAwesomeIcon icon={["fas", "edit"]} />
                        </span>
                      </Link>
                    )}
                  </span>
                )}
                {allowHtml ? (
                  <div className="body-comment comment-chim" dangerouslySetInnerHTML={createTopicComment(topic.comment)} />
                ) : (
                  <div className="body-comment comment-annoymous">{topic.comment}</div>
                )}
                <div>
                  Posted by: <AuthorName user={{ ...topic.thread_author }} />
                  <DateWrapper>({topic.date})</DateWrapper>
                </div>
              </DetailsBody>
            </div>
          )}
        </Col>
        {topic && <CommentsList topic={topic} />}
      </Row>
    </div>
  );
};

MessageBoardTopic.propTypes = {
  preview: PropTypes.bool,
};

MessageBoardTopic.defaultProps = {
  preview: false,
};
export default MessageBoardTopic;
